import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion
});

export const api = {
  getList() {
    return instance.get("admin/black_list_ips");
  },
  removeBlackListIps() {
    return instance.post("admin/black_list_ips/destroy_all");
  },
  removeBlackListIp(param) {
    return instance.delete("admin/black_list_ips", { params: { blacklist_ip: { addr: param } } });
  }
};
